export default "__VITE_ASSET__D63Tw$1j__"